
import React, {useState, useRef,useEffect, useContext } from 'react'

import SelectionBox from 'GlobalComponents/SelectionBox/SelectionBox.js';
import { QuoteMasterContext } from 'Contexts/QuoteMasterContext.js';

export default function UserTypeSelect({user, setUser}) {
    const [userType, setUserType] = useState(user.userType);
    const {userOptions} = useContext(QuoteMasterContext);
    const firstLoadCompleted = useRef(false);   

    useEffect(() => {
        if(firstLoadCompleted.current){ // if the page is just loading for the first time
            const newUser = {...user};
            newUser.userType = userType;
            setUser(newUser);
        } else {
            firstLoadCompleted.current = true;
        }
    }, [userType]);

    useEffect(() => {
        setUserType(user.userType);
    }, [user.userType]);

    return (
        <SelectionBox 
            selectionItems={userOptions} 
            mainFunction={setUserType} 
            mainValue={userType} 
            instanceName={'Tipo Usuário'} 
            readOnly={false}
        />
    );
}